// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PW7nYIxJ{margin-top:var(--space)}`, "",{"version":3,"sources":["webpack://./src/widgets/dialogs/BranchDialog.module.scss"],"names":[],"mappings":"AAAA,UACE,uBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressContainer": `PW7nYIxJ`
};
export default ___CSS_LOADER_EXPORT___;
